import { LOCALES } from 'utils/constants/general/locales';

const homepagePaths = LOCALES.map((locale) => `/${locale.id}`);

export function onHomepage(pathname: string) {
  return homepagePaths.includes(pathname);
}
